import { render } from "./LeftRuler.vue?vue&type=template&id=8bcbb8bc&scoped=true&ts=true"
import script from "./LeftRuler.vue?vue&type=script&lang=ts"
export * from "./LeftRuler.vue?vue&type=script&lang=ts"

import "./LeftRuler.vue?vue&type=style&index=0&id=8bcbb8bc&scoped=true&lang=css"

import exportComponent from "/home3/sli/web/public/resources/editorvue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8bcbb8bc"]])

export default __exports__